import * as constants from './constants';

export const initialState = {
  insuranceCompanies: [],
  insuranceCompany: {},
  newConfirmation: [],
  changedConfirmation: [],
  deletedConfirmation: [],
  vehicleInsurancePolicies: [],
  createdPolicies: [],
  error: null,
};

const insurancesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_INSURANCE_COMPANIES_SUCCESS:
    case constants.FETCH_INSURANCE_COMPANIES_FAIL:
    case constants.FETCH_INSURANCE_COMPANY_SUCCESS:
    case constants.FETCH_INSURANCE_COMPANY_FAIL:
    case constants.FETCH_CONFIRMATION_NEW_SUCCESS:
    case constants.FETCH_CONFIRMATION_NEW_FAIL:
    case constants.FETCH_CONFIRMATION_CHANGED_SUCCESS:
    case constants.FETCH_CONFIRMATION_CHANGED_FAIL:
    case constants.FETCH_CONFIRMATION_DELETED_SUCCESS:
    case constants.FETCH_CONFIRMATION_DELETED_FAIL:
    case constants.COPY_CONFIRMATION_SUCCESS:
    case constants.COPY_CONFIRMATION_FAIL:
    case constants.FETCH_VEHICLE_INSURANCE_POLICIES_SUCCESS:
    case constants.FETCH_VEHICLE_INSURANCE_POLICIES_FAIL:
    case constants.CREATE_VEHICLE_INSURANCE_POLICY_SUCCESS:
    case constants.CREATE_VEHICLE_INSURANCE_POLICY_FAIL:
    case constants.UPDATE_VEHICLE_INSURANCE_POLICY_SUCCESS:
    case constants.UPDATE_VEHICLE_INSURANCE_POLICY_FAIL:
    case constants.SET_CONFIRMATION_DELETED_ROW:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default insurancesReducer;
